// src/theme/tokens/colors.js
export const colors = {
  white: '#ffffff',
  black: '#000000',
  grey: {
    50: '#F8FAFC',
    100: '#FAFAFA',
    200: '#F3F4F6',
    300: '#E2E8F0',
    400: '#D0D5DD',
    500: '#94A3B8',
    600: '#475569',
    700: '#334155',
    800: '#0F172B',
    900: '#0f172a',
  },
  // We can add absolute static colors here if they never change across tenants
};
